import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageJaLite() {
    return (
        <div className="privacy-policy-container">
 <h1>タスビーフ・ディクル・ライト プライバシーポリシー</h1>
      <p>最終更新日: 2024年1月31日</p>

      <h2>はじめに</h2>
      <p>タスビーフ・ディクル・ライトアプリへようこそ。このプライバシーポリシーは、アプリを使用する際にお客様のデータをどのように扱うかについてご説明することを目的としています。このアプリでのデータ収集はGoogleの広告サービスであるAdMobによってのみ行われ、私たちは積極的に個人データを収集しません。</p>

      <h2>1. お客様の個人データの収集と利用</h2>
      <h3>a. 収集されるデータの種類</h3>
      <h4>i. AdMobを通じたデータ利用</h4>
      <p>当アプリは広告を表示するためにAdMobを使用しています。AdMobはお客様のIPアドレス、デバイスID、アプリ利用情報などのデータを収集することがあります。これらの情報は広告体験を提供し、改善するために使用されます。</p>

      <h3>b. データの利用目的</h3>
      <p>AdMobによって収集されるデータは以下の目的で利用されます：</p>
      <ul>
        <li>アプリ内での広告の提供およびパーソナライズ。</li>
        <li>表示される広告の効果分析。</li>
      </ul>

      <h3>c. ユーザーのコントロール</h3>
      <p>お客様は、デバイスの設定を通じて、パーソナライズされた広告に対するデータの使用を制御することができます。</p>

      <h2>2. データの転送</h2>
      <p>お客様の情報は、お客様の居住国、州、地域のデータ保護法と異なる場合があるコンピュータに転送され、保持される可能性があります。</p>

      <h2>3. お客様の個人データの開示</h2>
      <p>AdMobによって収集されたデータは、Googleのプライバシーポリシーおよび法的要件に従って共有されることがあります。</p>

      <h2>4. お客様の個人データの安全性</h2>
      <p>お客様のデータの安全性は私たちにとって重要です。しかし、インターネット上の送信方法や電子的な保存方法は100%安全ではありません。</p>

      <h2>5. 他サイトへのリンク</h2>
      <p>当サービスには他のサイトへのリンクが含まれている場合があります。第三者のリンクをクリックすると、その第三者のサイトにリダイレクトされます。</p>

      <h2>6. このプライバシーポリシーの変更</h2>
      <p>私たちは時々プライバシーポリシーを更新する可能性があります。変更がある場合は、このページに新しいプライバシーポリシーを掲載することでお知らせします。</p>

      <h2>7. お問い合わせ</h2>
      <p>このプライバシーポリシーに関してご質問がある場合は、お問い合わせください。</p>

      <h2>役立つリンク</h2>
      <p><a href="https://policies.google.com/privacy">Googleのプライバシーポリシー</a></p>
    </div>
    );
}

export default PrivacyPolicyPageJaLite;
